import { fadeIn, fadeOut, shadows, color } from '@foxrenderfarm/common/src/theme'
import styled, { css } from 'styled-components'

export const Mask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  touch-action: none;
  transform: scale(1);
  background-color: rgba(0, 0, 0, 0.5);
  &.entering {
    ${css`
      animation: ${fadeIn} 300ms;
    `};
  }
  &.exiting {
    ${css`
      animation: ${fadeOut} 300ms;
    `};
  }
`

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: scroll;
`

export const Content = styled.div<{ darkTheme?: boolean }>`
  position: relative;
  display: flex;
  max-height: 80vh;
  flex-direction: column;
  background-color: ${(props) => (props.darkTheme ? color.textDark : 'white')};
  z-index: 10001;
  padding: 10px;
  box-shadow: ${shadows[3]};
  padding-top: 50px;
`

export const ContentInner = styled.div`
  flex: 1;
  overflow-y: auto;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 5px 10px;
  z-index: 2;
  > h6 {
    margin: 0;
    height: 2em;
    line-height: 2em;
    color: #333;
    font-size: 1.5rem;
    padding-left: 20px;
  }
`

export const HeaderTitle = styled.p`
  font-size: 1.5em;
  line-height: 40px;
  color: #333333;
  font-family: 'MarkPro';
`
